module.exports = __webpack_public_path__ + "static/media/0031_Medium.458f0d62.jpg";